<script>
  export let size = "small";
</script>

<!-- Social media -->
<article>
  <a href="https://fb.me/garageatugusto" target="_blank">
    <ion-icon name="logo-facebook" {size} />
  </a>
  <a href="https://m.me/garageatugusto" target="_blank">
    <ion-icon name="chatbubble-ellipses-outline" {size} />
  </a>
</article>

<style>
  ion-icon {
    color: ghostwhite;
  }
</style>
